var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as moment from 'moment';
var isInfiniteLimit = function (accountLimit) {
    return accountLimit === null || accountLimit === undefined;
};
var ɵ0 = isInfiniteLimit;
export function hideRecordingsNotAvailableInPlan(recordingsStorageDays, object) {
    if (isInfiniteLimit(recordingsStorageDays)) {
        return object;
    }
    var eventDate = moment(object.createdAt);
    var eventRecordingAvailableInPlan = moment().diff(eventDate, 'days') < recordingsStorageDays;
    var recordingAvailable = object.recordingAvailable && eventRecordingAvailableInPlan;
    var callStartDate = moment(object.startDate);
    var callRecordingAvailableInPlan = moment().diff(callStartDate, 'days') < recordingsStorageDays;
    var recordingExists = object.recordingExists && callRecordingAvailableInPlan;
    return __assign({}, object, { recordingAvailable: recordingAvailable, recordingExists: recordingExists });
}
export { ɵ0 };
